






































import { Component, Prop } from 'vue-property-decorator';

import { ValidationMessageCpt, BaseInputComponent } from '.';
import { DirectiveOptions } from 'vue';

// This is to add an aria-label to the upload input, and make it readable by screen readers
const SetAriaRequiredDirective: DirectiveOptions = {
  inserted(el, binding) {
    setTimeout(() => {
      const input = el.querySelector('.el-input__inner');
      input?.setAttribute('aria-required', binding.value);
    }, 100); // Ensure input is fully rendered before modifying it
  },
};

@Component({
  components: {
    ValidationMessageCpt,
  },
  directives: {
    setAriaRequired: SetAriaRequiredDirective,
  },
})
export default class InputDateCpt extends BaseInputComponent {
  @Prop({ default: 'yyyy-MM-dd' }) valueFormat: string;
  @Prop({ default: 'dd/MM/yyyy' }) format: string;
  @Prop({ default: '' }) startPlaceholder: string;
  @Prop({ default: '' }) endPlaceholder: string;
  @Prop({ default: '' }) rangeSeparator: string;
  @Prop({ default: false }) clearable: boolean;
  @Prop() pickerOptions?: any;

  addAccessibilityToDatePicker() {
    this.$nextTick(() => {
      // those are needed to add accessibility to these buttons
      // TypeScript 3.5.3 does not support the optional chaining (?.) operator.
      // Optional chaining was introduced in TypeScript 3.7.
      const nmButton = document.querySelector('.el-icon-arrow-right');
      if (nmButton) {
        nmButton.setAttribute('aria-label', 'Next Month');
      }
      const nyButton = document.querySelector('.el-icon-d-arrow-right');
      if (nyButton) {
        nyButton.setAttribute('aria-label', 'Next Year');
      }
      const pmButton = document.querySelector('.el-icon-arrow-left');
      if (pmButton) {
        pmButton.setAttribute('aria-label', 'Prev Month');
      }
      const pyButton = document.querySelector('.el-icon-d-arrow-left');
      if (pyButton) {
        pyButton.setAttribute('aria-label', 'Prev Year');
      }
    });
  }

  change(value: any) {
    super.onChange(value);
  }
}
